/**
 * The three readings of one persisted message row's `question` column, told apart by
 * its `kind`: a FORM card, a concept card, or an old interview-style question
 * (read-only history). Anything else is an ordinary message and reads as none of them.
 *
 * Both columns arrive as `JSONString`. Each is parsed once here and the parsed record
 * is handed to whichever reader the kind picks.
 */
import {
  parseConceptCard,
  parseFormAnswer,
  parseFormCard,
} from "./answers/form/parseForm";
import { parseLegacyExchange } from "./legacyExchange";
import type { AgentChatMessage } from "./types";
import { asRecord, asString } from "./wire";

type RowCards = Pick<
  AgentChatMessage,
  "legacy" | "form" | "formAnswer" | "concept"
>;

export const readRow = (rawQuestion: unknown, rawAnswer: unknown): RowCards => {
  const question = asRecord(rawQuestion);
  const answer = asRecord(rawAnswer);
  const cards: RowCards = {
    legacy: null,
    form: null,
    formAnswer: parseFormAnswer(answer),
    concept: null,
  };
  if (!question) return cards;

  switch (asString(question.kind)) {
    case "FORM":
      return { ...cards, form: parseFormCard(question) };
    case "CONCEPT":
      return { ...cards, concept: parseConceptCard(question) };
    default:
      return { ...cards, legacy: parseLegacyExchange(question, answer) };
  }
};
